import * as React from "react";
const SvgFiBrandsCcVisa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M24.073 4.433H.927c-.512 0-.927.4-.927.891v13.353c0 .492.415.891.927.891h23.146c.512 0 .927-.399.927-.89V5.323c0-.492-.415-.89-.927-.89M4.904 15.187l-1.368-5.085c-.084-.314-.156-.428-.408-.56-.413-.215-1.094-.416-1.695-.542l.042-.185h2.92c.373 0 .708.238.793.65l.722 3.688 1.788-4.338h1.804l-2.781 6.372zm3.914 0 1.42-6.372h1.718l-1.42 6.372zm4.806.101c-.768-.009-1.51-.162-1.91-.339l.31-1.397c.4.18.901.416 1.765.403.493-.008 1.023-.195 1.027-.623.002-.28-.221-.48-.891-.792-.651-.305-1.515-.817-1.503-1.734.01-1.24 1.205-2.106 2.902-2.106.66 0 1.193.138 1.606.282l-.3 1.351c-.77-.339-1.448-.316-1.695-.284-.495.061-.723.304-.728.534-.017.752 2.414.844 2.406 2.525-.005 1.323-1.185 2.18-2.989 2.18m7.472-.1-.207-.953h-2.204l-.357.952h-1.802l2.575-5.905a.78.78 0 0 1 .73-.467h1.466l1.386 6.372zm-1.917-2.259h1.424l-.52-2.393z"
    />
  </svg>
);
export default SvgFiBrandsCcVisa;
